/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientPrescriptions = sqliteTable('patient_prescriptions', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  encounter_id: text('encounter_id'),
  visit_id: text('visit_id'),
  appointment_id: text('appointment_id'),
  queue_id: text('queue_id'),
  item_name: text('item_name'),
  item_details: text('item_details'),
  inventory_item_id: text('inventory_item_id'),
  free_text_name: text('free_text_name'),
  item_name_snapshot: text('item_name_snapshot'),
  sku_snapshot: text('sku_snapshot'),
  generic_name_snapshot: text('generic_name_snapshot'),
  brand_name_snapshot: text('brand_name_snapshot'),
  strength_snapshot: text('strength_snapshot'),
  dosage_form_snapshot: text('dosage_form_snapshot'),
  route_snapshot: text('route_snapshot'),
  unit_snapshot: text('unit_snapshot'),
  default_instruction_snapshot: text('default_instruction_snapshot'),
  default_dosage_snapshot: text('default_dosage_snapshot'),
  usage_snapshot: text('usage_snapshot'),
  dose_snapshot: text('dose_snapshot'),
  dose_unit_snapshot: text('dose_unit_snapshot'),
  frequency_snapshot: text('frequency_snapshot'),
  duration_snapshot: text('duration_snapshot'),
  intake_timing: text('intake_timing'),
  dose_quantity: text('dose_quantity'),
  schedule_morning: integer('schedule_morning'),
  schedule_afternoon: integer('schedule_afternoon'),
  schedule_night: integer('schedule_night'),
  duration_value: integer('duration_value'),
  duration_unit: text('duration_unit'),
  instructions: text('instructions'),
  sort_order: integer('sort_order'),
  author_user_id: text('author_user_id'),
  author_name: text('author_name'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
